import React from 'react';
import { useLabels } from 'wsm-common-data';
import { isPagingNeeded } from '../../utils/pagination';
import { usePaginationContext } from '../../contexts/PaginationContext';
import PaginationButton from './PaginationButton';

const Pagination = () => {
	const labels = useLabels();
	const { itemsPerPage, totalCount, goToNextPage, goToPreviousPage } =
		usePaginationContext();

	const paging = {
		pageSize: itemsPerPage,
		totalCount
	};

	if (!isPagingNeeded(paging)) {
		return null;
	}

	return (
		<nav
			aria-label={labels.get('PAGE_NAVIGATION')}
			className="py-4 d-flex justify-content-center align-items-center"
		>
			<ul className="pagination">
				<PaginationButton
					direction="previous"
					onNavigate={goToPreviousPage}
				/>
				<PaginationButton direction="next" onNavigate={goToNextPage} />
			</ul>
		</nav>
	);
};

export default Pagination;
